module.exports = __webpack_public_path__ + "catalog/items/child-chair-desk/chairDesk.png";